"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kage = exports.KShotai = void 0;
var buhin_1 = require("./buhin");
var polygons_1 = require("./polygons");
var stroke_1 = require("./stroke");
var font_1 = require("./font");
var KShotai;
(function (KShotai) {
    KShotai[KShotai["kMincho"] = 0] = "kMincho";
    KShotai[KShotai["kGothic"] = 1] = "kGothic";
})(KShotai = exports.KShotai || (exports.KShotai = {}));
var Kage = /** @class */ (function () {
    function Kage(size) {
        // TODO: should be static
        this.kMincho = KShotai.kMincho;
        this.kGothic = KShotai.kGothic;
        this.kFont = font_1.select(KShotai.kMincho);
        this.stretch = stroke_1.stretch;
        this.kFont.setSize(size);
        this.kBuhin = new buhin_1.Buhin();
    }
    Object.defineProperty(Kage.prototype, "kShotai", {
        // properties
        get: function () {
            return this.kFont.shotai;
        },
        set: function (shotai) {
            this.kFont = font_1.select(shotai);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Kage.prototype, "kUseCurve", {
        get: function () {
            return this.kFont.kUseCurve;
        },
        set: function (value) {
            this.kFont.kUseCurve = value;
        },
        enumerable: false,
        configurable: true
    });
    // method
    Kage.prototype.makeGlyph = function (polygons, buhin) {
        var glyphData = this.kBuhin.search(buhin);
        this.makeGlyph2(polygons, glyphData);
    };
    Kage.prototype.makeGlyph2 = function (polygons, data) {
        var _this = this;
        if (data !== "") {
            var strokesArray = this.getEachStrokes(data);
            this.kFont.adjustStrokes(strokesArray);
            strokesArray.forEach(function (stroke) {
                _this.kFont.draw(polygons, stroke);
            });
        }
    };
    Kage.prototype.makeGlyph3 = function (data) {
        var _this = this;
        var result = [];
        if (data !== "") {
            var strokesArray = this.getEachStrokes(data);
            this.kFont.adjustStrokes(strokesArray);
            strokesArray.forEach(function (stroke) {
                var polygons = new polygons_1.Polygons();
                _this.kFont.draw(polygons, stroke);
                result.push(polygons);
            });
        }
        return result;
    };
    Kage.prototype.makeGlyphSeparated = function (data) {
        var _this = this;
        var strokesArrays = data.map(function (subdata) { return _this.getEachStrokes(subdata); });
        this.kFont.adjustStrokes(strokesArrays.reduce(function (left, right) { return left.concat(right); }, []));
        var polygons = new polygons_1.Polygons();
        return strokesArrays.map(function (strokesArray) {
            var startIndex = polygons.array.length;
            strokesArray.forEach(function (stroke) {
                _this.kFont.draw(polygons, stroke);
            });
            var result = new polygons_1.Polygons();
            result.array = polygons.array.slice(startIndex);
            return result;
        });
    };
    Kage.prototype.getEachStrokes = function (glyphData) {
        var _this = this;
        var strokesArray = [];
        var strokes = glyphData.split("$");
        strokes.forEach(function (stroke) {
            var columns = stroke.split(":");
            if (Math.floor(+columns[0]) !== 99) {
                strokesArray.push(new stroke_1.Stroke([
                    Math.floor(+columns[0]),
                    Math.floor(+columns[1]),
                    Math.floor(+columns[2]),
                    Math.floor(+columns[3]),
                    Math.floor(+columns[4]),
                    Math.floor(+columns[5]),
                    Math.floor(+columns[6]),
                    Math.floor(+columns[7]),
                    Math.floor(+columns[8]),
                    Math.floor(+columns[9]),
                    Math.floor(+columns[10]),
                ]));
            }
            else {
                var buhin = _this.kBuhin.search(columns[7]);
                if (buhin !== "") {
                    strokesArray = strokesArray.concat(_this.getEachStrokesOfBuhin(buhin, Math.floor(+columns[3]), Math.floor(+columns[4]), Math.floor(+columns[5]), Math.floor(+columns[6]), Math.floor(+columns[1]), Math.floor(+columns[2]), Math.floor(+columns[9]), Math.floor(+columns[10])));
                }
            }
        });
        return strokesArray;
    };
    Kage.prototype.getEachStrokesOfBuhin = function (buhin, x1, y1, x2, y2, sx, sy, sx2, sy2) {
        var strokes = this.getEachStrokes(buhin);
        var box = this.getBox(strokes);
        if (sx !== 0 || sy !== 0) {
            if (sx > 100) {
                sx -= 200;
            }
            else {
                sx2 = 0;
                sy2 = 0;
            }
        }
        strokes.forEach(function (stroke) {
            if (sx !== 0 || sy !== 0) {
                stroke.stretch(sx, sx2, sy, sy2, box.minX, box.maxX, box.minY, box.maxY);
            }
            stroke.x1 = x1 + stroke.x1 * (x2 - x1) / 200;
            stroke.y1 = y1 + stroke.y1 * (y2 - y1) / 200;
            stroke.x2 = x1 + stroke.x2 * (x2 - x1) / 200;
            stroke.y2 = y1 + stroke.y2 * (y2 - y1) / 200;
            stroke.x3 = x1 + stroke.x3 * (x2 - x1) / 200;
            stroke.y3 = y1 + stroke.y3 * (y2 - y1) / 200;
            stroke.x4 = x1 + stroke.x4 * (x2 - x1) / 200;
            stroke.y4 = y1 + stroke.y4 * (y2 - y1) / 200;
        });
        return strokes;
    };
    Kage.prototype.getBox = function (strokes) {
        var minX = 200;
        var minY = 200;
        var maxX = 0;
        var maxY = 0;
        strokes.forEach(function (stroke) {
            var _a = stroke.getBox(), sminX = _a.minX, smaxX = _a.maxX, sminY = _a.minY, smaxY = _a.maxY;
            minX = Math.min(minX, sminX);
            maxX = Math.max(maxX, smaxX);
            minY = Math.min(minY, sminY);
            maxY = Math.max(maxY, smaxY);
        });
        return { minX: minX, maxX: maxX, minY: minY, maxY: maxY };
    };
    Kage.Buhin = buhin_1.Buhin;
    Kage.Polygons = polygons_1.Polygons;
    return Kage;
}());
exports.Kage = Kage;
